import React from 'react'
import { useHistory } from 'react-router'
import { Tooltip, IconButton } from '@mui/material'
import { DocumentMagnifyingGlassIcon } from 'components/Icons'
// import CB from 'lib'
import { useAuthedUser } from 'context/AuthedUser/AuthedUserContext'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling'

export const ReviewCell = ({
    caseId,
    // setAlertProps,
    // setAlertOpen,
    rowIndex,
    rowData = {},
    filterTab = '',
}: {
    caseId: number
    setAlertProps: (props: any) => void
    setAlertOpen: (val: boolean) => void
    rowIndex: number
    rowData?: any
    filterTab?: string
}): React.ReactElement => {
    const history = useHistory()
    const { user } = useAuthedUser()
    const { clientTheme } = useThemeStyling()
    const isReadOnly = user?.is_read_only

    const handleClick = () => {
        history.push({
            pathname: `/case-qc-review/view-case/${caseId}`,
            state: {
                caseId,
                reviewType: 'qc-review',
                // Needed for Issuer client:
                filterTab: filterTab ?? '',
                caseType: rowData?.type ?? '',
            },
        })
    }

    return (
        <div id={'qcReviewReviewCell'}>
            <Tooltip title={'Review Document'} arrow placement="top">
                <div className={`${isReadOnly ? 'emp-disabledIcon' : ''}`}>
                    <IconButton
                        className={'emp-iconBtn'}
                        onClick={handleClick}
                        disabled={isReadOnly}
                        size="large"
                    >
                        <DocumentMagnifyingGlassIcon
                            className="emp-actionIcon"
                            id={`qcReview-document-icon-${rowIndex}`}
                            iconColor={
                                isReadOnly? '#bdbdbd'
                                    : clientTheme.icons.dnrAndRevertDnrIcon
                            }
                        />
                    </IconButton>
                </div>
            </Tooltip>
        </div>
    )
}
